import { useContext } from "react"
import { Route, Routes } from "react-router-dom";
import { Login } from "../Components/login";
import { Profile } from "../Components/profile";
import { Users } from "../Components/users";
import { GlobalContext } from "../Context/globalContext"

export const Routing = () => {

    const globalContext = useContext(GlobalContext);

    return (
        <>
            {globalContext.loggedIn ?
                <Routes>
                    <Route path="*" element={<Users />} />
                    <Route path="/settings" element={<Profile />} />
                </Routes>
                :
                <Routes>
                    <Route path="*" element={<Login />} />
                </Routes>
            }
        </>
    )

}